import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { Items } from 'app/core/models/items';
import { TranslateService } from '@ngx-translate/core';
import { NotifMessageService } from 'app/core/services/notifmessage.service';
import { WalletsByPeriod } from 'app/core/models/walletsByPeriod';
import { TransactionReportingService } from 'app/core/services/transaction-reporting.service';
import { Router } from '@angular/router';
import { BaseComponent } from 'app/base/base.component';

@Component({
  selector: 'app-transaction-evolution',
  templateUrl: './transaction-evolution.component.html',
  styleUrls: ['./transaction-evolution.component.css']
})
export class TransactionEvolutionComponent extends BaseComponent implements OnInit {
  transactionsEvolutionReportForm: FormGroup;
  periodSub: Subscription;
  subscription: Subscription;
  isLoading: boolean;
  period: number = 12;
  periodItems: Array<number> = Array<number>(3, 6, 12);
  transactionsEvolutionReport: Items<WalletsByPeriod>;
  fromDate: Date;
  reportData: number[];
  reportLabel: string[];
  reportTitle: string;

  criteria = {
    windowBegin: this.getFromDate(this.period),
    windowEnd: new Date()
  };

  displayedColumns= ['month','year','transactionCount'];

  constructor(
    private formBuilder: FormBuilder,
    private translate: TranslateService,
    private notifService: NotifMessageService,
    private txReportService: TransactionReportingService,
    router: Router) { super(router) }

  ngOnInit() {
    this.transactionsEvolutionReportForm = this.formBuilder.group({
      period: new FormControl(this.period, Validators.required)
    });

    this.getTxEvolutionByPeriod();

    this.periodSub = this.transactionsEvolutionReportForm.get("period").valueChanges.subscribe(val => {
      if (this.transactionsEvolutionReportForm.get("period").valid) {
        this.period = val;
        this.criteria.windowBegin = this.getFromDate(val);
        this.getTxEvolutionByPeriod();
      }
    });
  }

  getTxEvolutionByPeriod(): void {
    this.reportTitle = this.translate.instant("TRANSACTIONS_NUMBER_EVOLUTION");
    this.isLoading = true;
    this.txReportService.getTxEvolution(this.criteria).subscribe(
      items => {
        this.transactionsEvolutionReport = items;
        this.reportLabel = items.map(items => this.getMonthName(items.month) + " " + items.year);
        this.reportData = items.map(items => items.transactionCount);
        this.isLoading = false;
        if (items.empty) {
          this.notifService.notifyInfo('EMPTY_RESULT');
        }
      });
  }

  getMonthName(month: number): string {
    let monthName = this.monthMap.get(month);
    return this.translate.instant(monthName);
  }

  getFromDate(period: number): Date {
    this.fromDate = new Date();
    this.fromDate.setMonth(this.fromDate.getMonth() - period);
    return this.fromDate;
  }

  isActive(transactionsEvolutiontatus): boolean {
    if (transactionsEvolutiontatus == "ACTIVE")
      return true;
    return false;
  }

  date() {
    let frDateFormat = "dd MMM y";
    let usDateFormat = "MMM dd y";
    if (this.translate.currentLang == "fr_FR")
      return frDateFormat;
    else
      return usDateFormat;
  }

  locale() {
    if (this.translate.currentLang == "fr_FR")
      return "fr_FR";
    else
      return "en_US";
  }



  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.periodSub) {
      this.periodSub.unsubscribe();
    }
  }



}
